import {
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import { useHistory, NavLink, useLocation, useParams } from "react-router-dom";
import classnames from "classnames";

import { makeStyles } from "@material-ui/core/styles";
import FlagOutlinedIcon from "@material-ui/icons/FlagOutlined";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import { mdiDragVertical } from "@mdi/js";
import Icon from "@mdi/react";
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomAvatar from "components/CustomAvatar";
import { Routes } from "constants/routes";
import { get } from "lodash-es";
import React, { useEffect, useState } from "react";
import { Draggable } from "react-beautiful-dnd";
import { useSelector } from "react-redux";
import { useGetProjectSetting } from "hooks/useGetProjectSetting";
import { forwardToDefaultTaskView } from "./utils";
import { GroupProject as GroupProjectOther } from "../components";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { apiService } from "constants/axiosInstance";
import { ReactComponent as Workspaces } from "assets/workspaces.svg";
import "./index.scss";
import {
  CREATE_PROJECT_GROUP,
  CustomEventDispose,
  CustomEventListener,
  EDIT_PROJECT_GROUP,
} from "constants/events";
import { ReactComponent as GroupArticle } from "assets/article_black.svg";
import {
  Box,
  Button,
  Divider,
  MenuItem,
  MenuList,
  Popover,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  projectItem: {
    padding: "5px 0",
    paddingLeft: "45px",

    "&:hover, &.active": {
      backgroundColor: "#e5e5e5 !important",
      color: "#0076f3 !important",
      // "& $projectIconChecked": {
      //   display: "flex",
      //   "& svg": {
      //     width: "1.2em !important",
      //     height: "1.2em !important",
      //     fill: "#0076f3 !important",
      //   },
      // },
      "& $projectIconOutLine": {
        "& svg": {
          width: "1.3em !important",
          height: "1.3em !important",
          fill: "#0076f3 !important",
        },
      },
    },
  },
  projectItemActive: {
    backgroundColor: "#e5e5e5 !important",
    color: "#0076f3 !important",
    // "& $projectIconChecked": {
    //   display: "flex",
    // },
    "& $projectIconOutLine": {
      display: "flex",
      "& svg": {
        width: "1.3em !important",
        height: "1.3em !important",
        fill: "#0076f3 !important",
      },
    },
  },
  projectText: {
    "& span": {
      whiteSpace: "nowrap",
      width: 180,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  projectIcon: {
    minWidth: "auto",
    marginRight: 13,
  },
  projectIconChecked: { display: "none", color: "#0076f3 !important" },
  projectIconOutLine: {
    display: "flex",
    "& svg": {
      width: "1.3em",
      height: "1.3em",
      color: "#989898",
      fill: "#607d8b",
    },
  },
  groupName: {
    whiteSpace: "nowrap",
  },
}));

const PathNavLink = (props, level) => {
  const propsSearch = `?${props.to.split("?")[1]}`;
  const history = useHistory();
  return (
    <NavLink
      isActive={(_, { search }) => search === propsSearch}
      onClick={(e) => {
        e.preventDefault();
        // history.push(props.to);
      }}
      {...props}
      style={{ paddingLeft: `${level * 24}px` }}
    />
  );
};

export const GroupProject = ({
  projectGroup,
  groupID,
  index,
  setOpenCreateGroup,
  setAnchorElAddGroup,
  selectedGroup,
  setSelectedGroup,
  // anchorElGroup,
  // setAnchorElGroup,
  open,
  close,
  currentProjectGroup,
  onDragEnd,
  level,
  handleSetDefault,
  canModify,
  handleDeleteGroup,
  onChangePath = () => {},
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [anchorElGroup, setAnchorElGroup] = React.useState(null);
  const idGroupDefault = useSelector(
    ({ groupTask }) => groupTask.defaultGroupTask.data || ""
  );
  const idGroupDefaultLocal = localStorage.getItem(
    "WPS_WORKING_SPACE_DEFAULT_ACCESS"
  );
  // const params = new URLSearchParams(window.location.search);

  const [isActive, setIsActive] = useState(false);
  const isDefaultGroup =
    idGroupDefault === `?groupID=${projectGroup.id}` ||
    `?groupID=${projectGroup.id}` === idGroupDefaultLocal;

  function handleProjectActive(parentId) {
    // setIsActive(projectGroup.id === parentId);
  }

  const _openExpand = () => {
    open(projectGroup.id);
    setIsActive(true);
  };
  const _closeExpand = () => {
    close(null);
    setIsActive(false);
  };
  let dataProject = projectGroup?.projects ?? [];
  const activeMenu = history.location.search.includes(
    `?groupID=${projectGroup.id}`
  );

  return (
    <Box
      sx={
        {
          // "& > .view_ProjectGroup_List-customListItem-nav": {
          //   position: "relative",
          // },
        }
      }
    >
      <ListItem
        className={`view_ProjectGroup_List-customListItem view_ProjectGroup_List-customListItem-nav ${
          activeMenu ? "view_ProjectGroup_List-customListItem-nav-active" : ""
        }`}
        // component={(props) => PathNavLink(props, level)}
        // to={`/projects?groupID=${projectGroup.id}`}
        style={{ paddingLeft: `${level * 24}px` }}
      >
        {/* <div
              {...provided.dragHandleProps}
              className={"view_ProjectGroup_List-customListItem-dragIcon"}
            >
              <Icon path={mdiDragVertical} size={1} />
            </div> */}

        <ListItemIcon
          onClick={() => {
            history.push(`/projects?groupID=${projectGroup.id}`);
            onChangePath();
            open(projectGroup.id);
          }}
        >
          <div
            style={{
              // marginRight: "10px",
              width: 13,
              height: 13,
              borderRadius: 3,
              backgroundColor: get(projectGroup, "color"),
              marginLeft: 3,
            }}
            // src={get(projectGroup, "icon")}
            alt="avatar"
          >
            {/* <Workspaces className="ListItemIcon__icon" /> */}
          </div>
        </ListItemIcon>

        <ListItemText
          onClick={() => {
            history.push(`/projects?groupID=${projectGroup.id}`);
            onChangePath();
            open(projectGroup.id);
          }}
          primary={
            <div className="view_ProjectGroup_List-customListItem__textPrimary">
              <abbr
                className="view_ProjectGroup_List-customListItem__text"
                title={get(projectGroup, "name")}
              >
                {get(projectGroup, "name")}
              </abbr>
              {/* <div>
                (
                {projectGroup?.number_project +
                  projectGroup?.number_children_group}
                )
              </div> */}
            </div>
          }
        />

        {isDefaultGroup && <FlagOutlinedIcon htmlColor={"red"} />}

        <div className="wp-wrapper-button">
          <MoreVertIcon
            sx={{ color: "rgba(0,0,0,0.54)" }}
            onClick={(evt) => {
              evt.preventDefault();
              setAnchorElGroup(evt.currentTarget);
              // setSelectedGroup(projectGroup);
            }}
          />
        </div>
        {Boolean(anchorElGroup) && (
          <Popover
            open={Boolean(anchorElGroup)}
            anchorEl={anchorElGroup}
            // disableRestoreFocus
            anchorOrigin={{
              vertical: "center",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            onClose={(evt) => {
              evt.stopPropagation();
              setAnchorElGroup(null);
            }}
          >
            <Box className={"personalBoard-container"}>
              <Box className={"personalBoard-actionItemWrapper"}>
                <span className={"title"}>{t("LABEL_SET_DEFAULT")}</span>
                <Box className={"actionItem"}>
                  <Typography variant={"body2"} color={"textSecondary"}>
                    {t("LABEL_SET_DEFAULT_DES")}
                  </Typography>
                  <Button
                    color={"primary"}
                    onClick={(evt) => {
                      evt.stopPropagation();
                      setAnchorElGroup(null);
                      handleSetDefault(`?groupID=${projectGroup?.id}`);
                    }}
                  >
                    {t("LABEL_SET")}
                  </Button>
                </Box>
              </Box>
            </Box>
            {canModify && (
              <>
                <Divider />
                <MenuList>
                  <MenuItem
                    onClick={(evt) => {
                      evt.stopPropagation();
                      setAnchorElGroup(null);
                      setSelectedGroup(projectGroup);
                      setOpenCreateGroup(true);
                    }}
                  >
                    {t("IDS_WP_EDIT_TEXT")}
                  </MenuItem>
                  <MenuItem
                    onClick={(evt) => {
                      setAnchorElGroup(null);
                      setSelectedGroup(projectGroup);
                      handleDeleteGroup(evt);
                    }}
                  >
                    {t("IDS_WP_DELETE")}
                  </MenuItem>
                </MenuList>
              </>
            )}
          </Popover>
        )}
        <div className="wp-wrapper-button" onClick={(e) => e.preventDefault()}>
          {isActive ? (
            <KeyboardArrowDownOutlinedIcon
              sx={{ color: "rgba(0,0,0,0.54)" }}
              onClick={_closeExpand}
            />
          ) : (
            <KeyboardArrowRightOutlinedIcon
              sx={{ color: "rgba(0,0,0,0.54)" }}
              onClick={_openExpand}
            />
          )}
        </div>
      </ListItem>

      {/* {isActive && (
        
      )} */}
      <CollapseListProject
        level={level + 1}
        parentId={projectGroup.id}
        // data={projectGroup.projects}
        data={dataProject}
        isActive={isActive}
        onActive={handleProjectActive}
        onDragEnd={onDragEnd}
        setOpenCreateGroup={setOpenCreateGroup}
        setAnchorElAddGroup={setAnchorElAddGroup}
        setSelectedGroup={setSelectedGroup}
        setAnchorElGroup={setAnchorElGroup}
        onChangePath={onChangePath}
      />
    </Box>
    // <Draggable draggableId={get(projectGroup, "id")} index={index}>
    //   {(provided, snapshot) => (
    //     <div ref={provided.innerRef} {...provided.draggableProps}>
    //       <ListItem
    //         className="view_ProjectGroup_List-customListItem view_ProjectGroup_List-customListItem-nav"
    //         component={PathNavLink}
    //         onClick={() => _toggleExpand()}
    //         to={`/projects?groupID=${projectGroup.id}`}
    //       >

    //         <ListItemIcon>
    //           <div
    //             style={{
    //               // marginRight: "10px",
    //               width: 13,
    //               height: 13,
    //               borderRadius: 3,
    //               backgroundColor: get(projectGroup, "color"),
    //               marginLeft: 3,
    //             }}
    //             // src={get(projectGroup, "icon")}
    //             alt="avatar"
    //           >
    //             <Workspaces className="ListItemIcon__icon" />
    //           </div>
    //         </ListItemIcon>

    //         <ListItemText
    //           primary={
    //             <div className="view_ProjectGroup_List-customListItem__textPrimary">
    //               <abbr
    //                 className="view_ProjectGroup_List-customListItem__text"
    //                 title={get(projectGroup, "name")}
    //               >
    //                 {get(projectGroup, "name")}
    //               </abbr>
    //               <div>
    //                 (
    //                 {projectGroup?.number_project +
    //                   projectGroup?.number_children_group}
    //                 )
    //               </div>
    //             </div>
    //           }
    //           {...provided.dragHandleProps}
    //         />

    //         {isDefaultGroup && <FlagOutlinedIcon htmlColor={"red"} />}

    //         <div
    //           className="wp-wrapper-button"
    //           onClick={(evt) => {
    //             evt.preventDefault();
    //             setAnchorElGroup(evt.currentTarget);
    //             setSelectedGroup(projectGroup);
    //           }}
    //         >
    //           <MoreVertIcon sx={{ color: "rgba(0,0,0,0.54)" }} />
    //         </div>

    //         <div
    //           className="wp-wrapper-button"
    //           onClick={(e) => e.preventDefault()}
    //         >
    //           {isActive ? (
    //             <KeyboardArrowUpOutlinedIcon
    //               sx={{ color: "rgba(0,0,0,0.54)" }}
    //               onClick={_closeExpand}
    //             />
    //           ) : (
    //             <KeyboardArrowDownOutlinedIcon
    //               sx={{ color: "rgba(0,0,0,0.54)" }}
    //               onClick={_openExpand}
    //             />
    //           )}
    //         </div>
    //       </ListItem>

    //       <CollapseListProject
    //         parentId={projectGroup.id}
    //         data={projectGroup.projects}
    //         isActive={isActive}
    //         onActive={handleProjectActive}
    //         onDragEnd={onDragEnd}
    //         setOpenCreateGroup={setOpenCreateGroup}
    //         setAnchorElAddGroup={setAnchorElAddGroup}
    //         setSelectedGroup={setSelectedGroup}
    //         setAnchorElGroup={setAnchorElGroup}
    //       />
    //       {provided.placeholder}
    //     </div>
    //   )}
    // </Draggable>
  );
};

const CollapseListProject = ({
  parentId,
  onActive,
  data = [],
  isActive = true,
  onDragEnd,
  setOpenCreateGroup,
  setAnchorElAddGroup,
  setSelectedGroup,
  setAnchorElGroup,
  level,
  onChangePath = () => {},
}) => {
  const history = useHistory();
  const pathname = history.location.pathname;

  const getDetailProjectSetting = useGetProjectSetting();

  const forwardToView = async (item) => {
    const projectSetting = await getDetailProjectSetting(item.id);
    const taskView = projectSetting.data?.task_view;
    const tab = forwardToDefaultTaskView(taskView);

    if (tab) {
      history.push(`${tab}/${item.id}`);
    }
  };

  const classes = useStyles();

  const [currentProjectGroupSub, setCurrentProjectGroupSub] = React.useState();

  function handleOpen(projectGroupId) {
    setCurrentProjectGroupSub(projectGroupId);
  }
  function handleClose() {
    setCurrentProjectGroupSub(null);
  }
  const [groups, setGroups] = React.useState([]);
  const [loadedGroup, setLoadedGroup] = React.useState(false);
  const [dataProject, setDataProject] = React.useState([]);
  const [projectUpdated, setProjectUpdated] = React.useState(undefined);

  async function doListProjectGroup({ timeStart, timeEnd, projectGroupId }) {
    try {
      const config = {
        url: "/project-group/list",
        method: "get",
        params: {
          start_time: timeStart,
          end_time: timeEnd,
          parent_group: projectGroupId,
        },
      };

      const result = await apiService(config).then((data) => {
        setGroups(data?.data?.project_groups);
        setLoadedGroup(true);
        return data;
      });

      return result?.data;
    } catch (error) {
      throw error;
    }
  }

  useEffect(() => {
    let tmp = data;
    if (projectUpdated) {
      tmp = tmp.filter((item) => {
        if (item.id === projectUpdated.id) {
          return {
            ...item,
            ...projectUpdated,
          };
        }
        return item;
      });
    }
    setDataProject(tmp);
  }, [data, projectUpdated]);

  useEffect(() => {
    if (!!parentId && isActive && !loadedGroup) {
      doListProjectGroup({ projectGroupId: parentId });
    }
  }, [parentId, isActive, loadedGroup]);
  React.useEffect(() => {
    CustomEventListener(EDIT_PROJECT_GROUP.SUCCESS, () => {
      setLoadedGroup(false);
    });
    CustomEventListener(CREATE_PROJECT_GROUP.SUCCESS, () => {
      setLoadedGroup(false);
    });
    if (parentId) {
      CustomEventListener("UPDATE_LEFT_PROJECT_GROUP" + parentId, (detail) => {
        doListProjectGroup({ projectGroupId: parentId });
      });
      CustomEventListener("DELETE_LEFT_PROJECT_GROUP" + parentId, (detail) => {
        doListProjectGroup({ projectGroupId: parentId });
      });
      CustomEventListener("ADD_LEFT_PROJECT_GROUP" + parentId, (detail) => {
        doListProjectGroup({ projectGroupId: parentId });
      });
      CustomEventListener("SORT_LEFT_PROJECT_GROUP" + parentId, (detail) => {
        doListProjectGroup({ projectGroupId: parentId });
      });
      CustomEventListener("UPDATE_LEFT_PROJECT" + parentId, ({ detail }) => {
        setProjectUpdated(detail);
      });
    }
    return () => {
      CustomEventDispose(EDIT_PROJECT_GROUP.SUCCESS, () => {
        setLoadedGroup(false);
      });
      CustomEventDispose(CREATE_PROJECT_GROUP.SUCCESS, () => {
        setLoadedGroup(false);
      });
      if (parentId) {
        CustomEventDispose("UPDATE_LEFT_PROJECT_GROUP" + parentId, () => {});
        CustomEventDispose("DELETE_LEFT_PROJECT_GROUP" + parentId, () => {});
        CustomEventDispose("SORT_LEFT_PROJECT_GROUP" + parentId, () => {});
        CustomEventDispose("UPDATE_LEFT_PROJECT" + parentId, () => {});
      }
    };
    // eslint-disable-next-line
  }, []);
  return (
    <Collapse in={isActive}>
      <List component={"nav"} className={""}>
        {groups.length > 0 && (
          <div>
            {groups.map((projectGroup, index) => (
              <GroupProjectOther
                level={level}
                key={index}
                index={index}
                groupID={parentId}
                currentProjectGroup={currentProjectGroupSub}
                open={handleOpen}
                close={handleClose}
                // defaultAccessItem={defaultAccessItem}
                projectGroup={projectGroup}
                setOpenCreateGroup={setOpenCreateGroup}
                setAnchorElAddGroup={setAnchorElAddGroup}
                setSelectedGroup={setSelectedGroup}
                setAnchorElGroup={setAnchorElGroup}
                onChangePath={onChangePath}
              />
            ))}
          </div>
        )}
        {/* <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId={"droppable_sub_" + parentId}>
            {(provided, snapshot) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {groups.map((projectGroup, index) => (
                  <GroupProjectOther
                    key={index}
                    index={index}
                    groupID={parentId}
                    currentProjectGroup={currentProjectGroupSub}
                    open={handleOpen}
                    close={handleClose}
                    // defaultAccessItem={defaultAccessItem}
                    projectGroup={projectGroup}
                    setOpenCreateGroup={setOpenCreateGroup}
                    setAnchorElAddGroup={setAnchorElAddGroup}
                    setSelectedGroup={setSelectedGroup}
                    setAnchorElGroup={setAnchorElGroup}
                  />
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext> */}
      </List>
      <List component="div" disablePadding>
        {dataProject.map((item, index) => {
          return (
            <ListItem
              key={item.id}
              className={classnames(
                classes.projectItem,
                pathname.includes(item.id) && classes.projectItemActive
              )}
              isActive={(match, { pathname }) => {
                const id = pathname.split("/");
                if (id[3] === item.id) onActive(parentId);
                return id[3] === item.id;
              }}
              style={{ paddingLeft: level * 24 }}
              onClick={() => forwardToView(item)}
            >
              {/* <ListItemIcon
                className={[classes.projectIcon, classes.projectIconChecked]}
              >
                <GroupArticle />
              </ListItemIcon> */}

              <ListItemIcon
                className={[classes.projectIcon, classes.projectIconOutLine]}
              >
                <GroupArticle />
              </ListItemIcon>

              <ListItemText
                className={classes.projectText}
                primary={item.name}
              />
            </ListItem>
          );
        })}
      </List>
    </Collapse>
  );
};
